import { render } from "./Settings.vue?vue&type=template&id=4f36b2c0"
import script from "./Settings.vue?vue&type=script&lang=js"
export * from "./Settings.vue?vue&type=script&lang=js"

import "./Settings.vue?vue&type=style&index=0&id=4f36b2c0&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/wpcm/admin/settings/Settings.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4f36b2c0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4f36b2c0', __exports__)) {
    api.reload('4f36b2c0', __exports__)
  }
  
  module.hot.accept("./Settings.vue?vue&type=template&id=4f36b2c0", () => {
    api.rerender('4f36b2c0', render)
  })

}


export default __exports__